<template>
<div class="chapter">
<div class="inner_page">
<h1 class="head1">The Shadow of Death</h1>
<h1 class="head2">The Hunt for the Connecticut River Valley Killer</h1>
<p class="head3">Philip E. Ginsburg</p>
<div class="img_container1">
<img alt="image" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?51859436